import Seo from "../../../../src/components/seo";
import ogImage from "../../../../static/og-image/oggimage.png";
import * as React from 'react';
export default {
  Seo,
  ogImage,
  React
};